enum GeneralLedgerAccountState {
    Active = "ACTIVE",
    Deleted = "DELETED",
}
export default GeneralLedgerAccountState